import { render } from "./ReturnPolicySchemajson.vue?vue&type=template&id=acb9e84c"
import script from "./ReturnPolicySchemajson.vue?vue&type=script&lang=js"
export * from "./ReturnPolicySchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__